










































import axios from 'axios';
import env from '@/env';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Responsible } from '@/types';
import { Company } from '@/interfaces/Company';
import SaveButton from '@/components/App/SaveButton.vue';

@Component({
  components: { SaveButton }
})
export default class EditableResponsible extends Vue {
  @Prop()
  responsible!: Responsible;

  @Prop()
  index!: number;

  @Prop()
  companies!: Company[];

  async save() {
    const { responsible } = this;
    await axios.post(`${env.backend_url}/responsible/update/${responsible.id}`, responsible);
  }
}
